// Centralised social/contact links
export const SOCIAL = {
  instagram: "https://www.instagram.com/aoturoa.academy.nz/",
  facebook: "https://www.facebook.com/aoturoaacademy",
  linkedin: "#",
  email: "alex.amboy@aoturoaacademy.org.nz",
};

export const TAGLINE = "Make sex ed cool again.";
